import axios from "axios";
import React, { createContext, useContext, useEffect, useState } from "react";

const StateContext = createContext();

export const ContextProvider = ({children}) => {

    const printConsole = () => {
        console.log("Welcome from Context");
    }
    const [themeSettings , setThemeSettings] = useState(false);





    //============================== API ====================================
      
    //const baseUrl = "http://localhost:4004/" ;
    //const baseUrl = "http://dev.right-businesses.com/sgan_soug/";
    const baseUrl = " https://2dde-41-95-103-134.in.ngrok.io/";



    const [dataProducts , setDataProducts] = useState([])
    const [dataProductsLoading , setDataProductLoading] = useState(false);
    const [dataProductsErrMsg , setDataProductErrMsg] = useState("");
    const [dataProductsShowErrMsg , setDataProductShowErrMsg] = useState(false);
    const getAllProductsAndCategory = () => {
        axios.get(`${baseUrl}category/category-products`)
        .then( (res) => {
          //  console.log(res);
            setDataProducts(res.data.result);
            setDataProductLoading(true)
        })
        .catch( (err) => {
            //console.log(err);
            setDataProductLoading(false);
            setDataProductShowErrMsg(true);
            if (!err?.response) {
                setDataProductErrMsg("عذرا يوجد خطا في الخادم");
              }
              else {
                // console.log("Failed Add Category");
                setDataProductErrMsg("عذرا خطا في البيانات");
              }
        })
    }

    const [dataCompanies , setDataCompanies] = useState([])
    const [dataCompaniesLoading , setDataCompaniesLoading] = useState(false);
    const [dataCompaniesErrMsg , setDataCompaniesErrMsg] = useState("");
    const [dataCompaniesShowErrMsg , setDataCompanieshowErrMsg] = useState(false);
    const getAllCompanies = () => {
        axios.get(`${baseUrl}companies`)
        .then( (res) => {
           // console.log(res);
            setDataCompanies(res.data.result);
            setDataCompaniesLoading(true)
        })
        .catch( (err) => {
           // console.log(err);
            setDataCompaniesLoading(false);
            setDataCompanieshowErrMsg(true);
            if (!err?.response) {
                setDataCompaniesErrMsg("عذرا يوجد خطا في الخادم");
              }
              else {
                // console.log("Failed Add Category");
                setDataCompaniesErrMsg("عذرا خطا في البيانات");
              }
        })
    }


    const [dataClub , setDataClub] = useState([])
    const [dataClubLoading , setDataClubLoading] = useState(false);
    const [dataClubErrMsg , setDataClubErrMsg] = useState("");
    const [dataClubShowErrMsg , setDataClubhowErrMsg] = useState(false);
    const getAllClub = () => {
        axios.get(`${baseUrl}club`)
        .then( (res) => {
           // console.log(res);
            setDataClub(res.data.result);
            setDataClubLoading(true)
        })
        .catch( (err) => {
          //  console.log(err);
            setDataClubLoading(false);
            setDataClubhowErrMsg(true);
            if (!err?.response) {
                setDataClubErrMsg("عذرا يوجد خطا في الخادم");
              }
              else {
                // console.log("Failed Add Category");
                setDataClubErrMsg("عذرا خطا في البيانات");
              }
        })
    }





    const [dataOneCompany , setDataOneCompany] = useState([])
    const [dataOneCompanyLoading , setDataOneCompanyLoading] = useState(false);
    const [dataOneCompanyErrMsg , setDataOneCompanyErrMsg] = useState("");
    const [dataOneCompanyShowErrMsg , setDataOneCompanyhowErrMsg] = useState(false);
    const getOneCompany = (id) => {
        axios.get(`${baseUrl}companies/info-company/${id}`)
        .then( (res) => {
           // console.log(res);
            setDataOneCompany(res.data);
            setDataOneCompanyLoading(true);
            setDataOneCompanyhowErrMsg(false);
        })
        .catch( (err) => {
           // console.log(err);
            setDataOneCompanyLoading(false);
            setDataOneCompanyhowErrMsg(true);
            if (!err?.response) {
                setDataOneCompanyErrMsg("عذرا يوجد خطا في الخادم");
              }
              else {
                // console.log("Failed Add Category");
                setDataOneCompanyErrMsg("عذرا خطا في البيانات");
              }
        })
    }


    const [dataOneClub , setDataOneClub] = useState([])
    const [dataOneClubLoading , setDataOneClubLoading] = useState(false);
    const [dataOneClubErrMsg , setDataOneClubErrMsg] = useState("");
    const [dataOneClubShowErrMsg , setDataOneClubhowErrMsg] = useState(false);
    const getOneClub = (id) => {
        axios.get(`${baseUrl}club/info-Club/${id}`)
        .then( (res) => {
           // console.log(res);
            setDataOneClub(res.data);
            setDataOneClubLoading(true)
            setDataOneClubhowErrMsg(false);
        })
        .catch( (err) => {
           // console.log(err);
            setDataOneClubLoading(false);
            setDataOneClubhowErrMsg(true);
            if (!err?.response) {
                setDataOneClubErrMsg("عذرا يوجد خطا في الخادم");
              }
              else {
                // console.log("Failed Add Category");
                setDataOneClubErrMsg("عذرا خطا في البيانات");
              }
        })
    }

    
    //=======================================================================

    return (
        <StateContext.Provider value={{
            printConsole , themeSettings , setThemeSettings,
            baseUrl ,
            getAllProductsAndCategory , dataProducts , dataProductsLoading , dataProductsErrMsg , dataProductsShowErrMsg ,
            getAllCompanies , dataCompanies , dataCompaniesLoading , dataCompaniesErrMsg , dataCompaniesShowErrMsg ,
            getAllClub , dataClub , dataClubLoading , dataClubErrMsg , dataClubShowErrMsg ,
            getOneCompany ,dataOneCompany , dataOneCompanyLoading , dataOneCompanyErrMsg , dataOneCompanyShowErrMsg,
            getOneClub , dataOneClub , dataOneClubLoading , dataOneClubErrMsg , dataOneClubShowErrMsg
        }}>
            {children}
        </StateContext.Provider>
    )
}

export const useStateContext = () => useContext(StateContext)
